import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import ComparisonPage from "./components/ComparisonPage";
import FAQSection from "./components/FAQSection";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import PopupForm from "./components/PopupForm";
import FloatingButtons from "./components/FloatingButtons";
function App() {
  return (
    <>
    <PopupForm />
      <Navbar />
      <Home />
      <About />
         <Contact />
        <Testimonials/>
      <Services />
      <ComparisonPage />
      <FAQSection />
      <FloatingButtons/>
      <Footer />
  
    </>
  );
}

export default App;